var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4930_4055",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4930_4055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0571 10.6321C12.3317 9.82192 13.6424 6.55315 16.9143 6.55315C19.8234 6.55315 21.8284 8.99486 21.8284 11.8875C21.8284 15.231 19.3306 17.4197 13.1436 22.7759C12.5769 23.2666 11.7279 23.2671 11.1569 22.7814C5.85624 18.2723 2.17188 15.6566 2.17188 11.8875C2.17188 8.99486 4.17686 6.55315 7.08604 6.55315C10.358 6.55315 11.6686 9.82192 11.9432 10.6321",
    stroke: "#64B98B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83771 2.98276C7.83771 4.13205 6.90604 5.06372 5.75674 5.06372C4.60745 5.06372 3.67578 4.13205 3.67578 2.98276C3.67578 1.83347 4.60745 0.855553 5.75674 0.855553C6.90604 0.855553 7.83771 1.83347 7.83771 2.98276Z",
    stroke: "#64B98B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0818 12.6939C14.0818 13.8432 13.1502 14.7749 12.0009 14.7749C10.8516 14.7749 9.91992 13.8432 9.91992 12.6939C9.91992 11.5446 10.8516 10.613 12.0009 10.613C13.1502 10.613 14.0818 11.5446 14.0818 12.6939Z",
    stroke: "#64B98B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.324 2.983C20.324 4.13229 19.3924 5.06396 18.2431 5.06396C17.0938 5.06396 16.1621 4.13229 16.1621 2.983C16.1621 1.83371 17.0938 0.855797 18.2431 0.855797C19.3924 0.855797 20.324 1.83371 20.324 2.983Z",
    stroke: "#64B98B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94727 11.8616C4.94727 13.4 6.28754 14.9177 8.8783 17.1736C9.48487 17.7018 9.52446 18.6388 8.95575 19.2075C8.43764 19.7257 7.60502 19.7474 7.052 19.2667C7.04404 19.2598 7.03609 19.2529 7.02818 19.246",
    stroke: "#64B98B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8457 17.1452C9.74144 16.5251 10.8285 16.1618 12.0005 16.1618C13.2064 16.1618 14.3224 16.5464 15.2326 17.1997",
    stroke: "#64B98B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0111 19.3251C17.0124 19.3278 17.0137 19.3305 17.015 19.3333L17.0383 19.3121C16.4879 19.8124 15.6376 19.8001 15.1116 19.2742C14.551 18.7135 14.5814 17.7915 15.1681 17.2583C18.0476 14.6416 19.0535 13.317 19.0535 11.8616",
    stroke: "#64B98B",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupol);
export default __webpack_public_path__ + "static/media/groupol.5594f5640658e3bc0ced676730535aab.svg";
export { ForwardRef as ReactComponent };